import { useTranslation } from 'react-i18next'
import styled from 'styled-components'

import * as themeUtilities from '@/utilities/client-components/utilities/themeUtils'

import StyledAction from './StyledAction'

const StyledOverlay = styled.div`
  position: absolute;
  inset: 0;
  background: rgb(100 100 100 / 30%);
  display: flex;
  flex-direction: column;
  align-content: center;
  justify-content: flex-end;
  z-index: ${({ theme }: any) => theme.baseZ + 2};
`

const StyledLabel = styled.div`
  color: white;
  text-align: center;
  background: rgb(50 50 50 / 90%);
  padding: 13px;

  p {
    font-size: ${({ theme }: any) => themeUtilities.getFontSize(theme, 'medium')}px;
    margin: 0 0 6px;
  }
`

interface DeletedOverlayProps {
  onRemove?(...args: unknown[]): unknown
  show?: boolean
}

const DeletedOverlay = ({ onRemove }: DeletedOverlayProps) => {
  const { t } = useTranslation('client')

  return (
    <StyledOverlay>
      <StyledLabel>
        <p>{t('client:DeletedOverlay.deleted')}</p>
        {onRemove && (
          <StyledAction color={'secondary'} onClick={onRemove}>
            {t('client:DeletedOverlay.removeButton')}
          </StyledAction>
        )}
      </StyledLabel>
    </StyledOverlay>
  )
}

DeletedOverlay.displayName = 'DeletedOverlay'

export default DeletedOverlay
